import React from 'react';
import OmnitureUtils from '../../../../../../../../../common/utils/Omniture/OmnitureUtils';
import { getCardLink } from '../../../../../../../../helpers/utils';
import './style.scss';

const DidYouKnowCard = ({ cardData, sectionCode, sectionOrder, sectionId, sectionHeader }) => {
  const {
    image = '',
    destination = '',
    genericSectionCardDynamicDetail = {},
    deeplink = '',
    dynamic = false,
  } = cardData;
  const isNotClickable = !!(!dynamic && !deeplink);

  const handleCardClick = card => {
    const SectionOmnitureText = `${sectionCode}_${sectionOrder}_${sectionId}_${sectionHeader}`;
    const { id, order, header } = card;
    OmnitureUtils.trackClickEvent({
      prop54: `${SectionOmnitureText}|Card_${order}_${id}_${header}`,
    });
    const url = getCardLink(card);
    if (url !== '') {
      window.open(url, '_blank');
    }
  };

  return (
    <div
      className={`did-you-know-card-wrapper ${isNotClickable ? '' : 'pointer'}`}
      onClick={isNotClickable ? null : () => handleCardClick(cardData)}
    >
      <div className="did-you-know-image-wrapper">
        <span className="background-gradient" />
        <img src={image} alt="DYK package Image" />
      </div>
      <div className="did-you-know-card-content">
        <p className="destination">{destination}</p>
        <div className="price-details-wrapper">
          <p>
            <span>{genericSectionCardDynamicDetail?.subHeader}</span>
            <span>&nbsp;{genericSectionCardDynamicDetail?.price}</span>
          </p>
          <span>{genericSectionCardDynamicDetail?.subText}</span>
        </div>
      </div>
    </div>
  );
};

export default DidYouKnowCard;
